import { render, staticRenderFns } from "./ColorRunPreview.vue?vue&type=template&id=05d7ce8c&scoped=true"
import script from "./ColorRunPreview.vue?vue&type=script&lang=js"
export * from "./ColorRunPreview.vue?vue&type=script&lang=js"
import style0 from "./ColorRunPreview.vue?vue&type=style&index=0&id=05d7ce8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7ce8c",
  null
  
)

export default component.exports